import type { Nhom } from '@qlk/shared';
import { useState } from 'react';

import { HopThoai, Nut, O, homNayVn } from '../../../ui/index.js';
import { useDanhSachKenhGon, useDatKenhNhom } from '../api.js';
import { ONhieuKenh } from './ONhieuKenh.js';

export interface HopKenhCuaNhomProps {
  nhom: Nhom;
  /** Kênh đang thuộc nhóm này ở kỳ đang xem. */
  dangCo: string[];
  onDong: () => void;
}

/**
 * Chọn kênh cho nhóm, **có ngày hiệu lực**.
 *
 * Bỏ một kênh ra không xoá lịch sử: máy chủ đóng dòng cũ ở ngày liền trước ngày
 * hiệu lực, nên kỳ trước vẫn chia cho trưởng nhóm cũ.
 */
export function HopKenhCuaNhom({ nhom, dangCo, onDong }: HopKenhCuaNhomProps) {
  const danhSach = useDanhSachKenhGon();
  const luu = useDatKenhNhom();

  const [chon, setChon] = useState<string[]>(dangCo);
  const [hieuLucTu, setHieuLucTu] = useState(homNayVn());

  const kenh = danhSach.data?.items.map((k) => ({ id: k.id, name: k.name })) ?? [];

  return (
    <HopThoai
      title={`Kênh của nhóm ${nhom.name}`}
      rong="lg"
      onDong={onDong}
      chanHop={
        <>
          {luu.isError && (
            <p role="alert" className="mr-auto self-center text-phu text-bad-chu">
              {luu.error.message}
            </p>
          )}
          <Nut kieu="phu" onClick={onDong}>
            Huỷ
          </Nut>
          <Nut
            kieu="chinh"
            disabled={hieuLucTu === ''}
            dangChay={luu.isPending}
            onClick={() => {
              luu.mutate({ id: nhom.id, channelIds: chon, hieuLucTu }, { onSuccess: onDong });
            }}
          >
            Lưu
          </Nut>
        </>
      }
    >
      <O
        label="Hiệu lực từ ngày"
        type="date"
        value={hieuLucTu}
        onChange={setHieuLucTu}
        required
        moTa="Kỳ trước vẫn chia theo nhóm cũ"
      />

      <p className="mb-2 mt-4 text-phu text-chu-mo">
        Đã chọn {chon.length} / {kenh.length} kênh. Một kênh chỉ thuộc một nhóm tại một thời điểm —
        chọn ở đây sẽ gỡ kênh khỏi nhóm cũ kể từ ngày hiệu lực.
      </p>

      <ONhieuKenh
        kenh={kenh}
        chon={chon}
        onDoi={(id) => {
          setChon((cu) => (cu.includes(id) ? cu.filter((x) => x !== id) : [...cu, id]));
        }}
        onDatLai={setChon}
      />
    </HopThoai>
  );
}
